// src/modules/app-views/omnichannel/pages/Init/components/TranslateProgressOverlay.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Button, Flex, Progress, theme } from 'antd';
import { TRANSLATE_LANGUAGES, renderFlag } from './TranslateLanguageSelect';
import { getCountryMetadata } from 'utils/phone';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const OVERLAY_BASE = {
  position: 'absolute',
  inset: 0,
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

// *******************************************************************************
// COMPONENT
// *******************************************************************************
const TranslateProgressOverlay = ({ translateProgress, onCancel, isDark, token: tokenProp }) => {
  const { token } = theme.useToken();
  const activeToken = tokenProp || token;

  const overlayStyle = {
    ...OVERLAY_BASE,
    backgroundColor: isDark ? 'rgba(0, 0, 0, 0.45)' : 'rgba(255, 255, 255, 0.45)',
  };

  const labelStyle = {
    fontSize: 13,
    fontWeight: 500,
    color: token.colorTextSecondary,
  };

  return (
    <div style={overlayStyle}>
      <Flex vertical align="center" gap={16}>
        <Flex align="center" gap={12}>
          {renderTranslateFlags(translateProgress.toLang, token.colorTextSecondary)}
        </Flex>

        <Progress
          type="circle"
          percent={
            translateProgress.total > 0
              ? Math.round((translateProgress.done / translateProgress.total) * 100)
              : 0
          }
          size={80}
          strokeColor={activeToken.colorPrimary}
        />

        <span style={labelStyle}>
          {translateX('translating')}... {translateProgress.done}/{translateProgress.total}
        </span>

        {onCancel && (
          <Button size="small" danger onClick={onCancel} style={{ marginTop: 4 }}>
            {translateX('cancel')}
          </Button>
        )}
      </Flex>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default TranslateProgressOverlay;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function renderTranslateFlags(toLang, arrowColor) {
  const toEntry = TRANSLATE_LANGUAGES.find(l => l.lang === toLang);
  const toMeta = toEntry ? getCountryMetadata(toEntry.country) : null;
  const toFlag = toEntry ? renderFlag(toMeta, toEntry.country) : toLang;

  return (
    <>
      <span style={{ fontSize: 28 }}>{toFlag}</span>
      <span style={{ fontSize: 16, color: arrowColor, fontWeight: 600 }}>
        {toEntry ? toMeta?.names?.pt || toMeta?.names?.en || toLang : toLang}
      </span>
    </>
  );
}
